import { Clickable, Col, Input, Row, Text } from 'components';
import { theme } from 'lib';
import React from 'react';
import { FiPlus, FiTrash2 } from 'react-icons/fi';
import styled from 'styled-components';

// Icon images
import iconTicket from 'assets/images/icon/icon-ticket.png';
import iconStadium from 'assets/images/icon/icon-stadium.png';
import iconRaffle from 'assets/images/icon/icon-raffle.png';
import iconGold from 'assets/images/icon/icon-gold.png';
import iconMail from 'assets/images/icon/icon-mail.png';
import iconSeat from 'assets/images/icon/icon-seat.png';
import iconJersey from 'assets/images/icon/icon-jersey.png';
import iconSilverGold from 'assets/images/icon/icon-silver-gold.png';
import iconMegaphone from 'assets/images/icon/icon-megaphone.png';
import iconAllTiers from 'assets/images/icon/icon-all-tiers.png';
import iconSeatPremium from 'assets/images/icon/icon-seat-premium.png';
import iconGift from 'assets/images/icon/icon-gift.png';
import iconStar from 'assets/images/icon/icon-star.png';

const NoteRow = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  background: ${theme.GREY_10};
  border-radius: 8px;
  margin-bottom: 8px;
  gap: 12px;
`;

const IconSelectWrapper = styled.div`
  position: relative;
  min-width: 150px;
`;

const IconSelect = styled.select`
  padding: 8px 12px 8px 40px;
  border: 1px solid ${theme.GREY_30};
  border-radius: 6px;
  background: white;
  font-size: 14px;
  width: 100%;
  cursor: pointer;
  appearance: none;

  &:focus {
    outline: none;
    border-color: ${theme.PRIMARY};
  }
`;

const IconPreview = styled.img`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  object-fit: contain;
  pointer-events: none;
`;

const AddButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background: transparent;
  border: 1px dashed ${theme.GREY_40};
  border-radius: 8px;
  color: ${theme.GREY_60};
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;

  &:hover {
    border-color: ${theme.PRIMARY};
    color: ${theme.PRIMARY};
    background: ${theme.PRIMARY}10;
  }
`;

const ICON_IMAGES = {
  ticket: iconTicket,
  stadium: iconStadium,
  raffle: iconRaffle,
  gold: iconGold,
  mail: iconMail,
  seat: iconSeat,
  jersey: iconJersey,
  'silver-gold': iconSilverGold,
  megaphone: iconMegaphone,
  'all-tiers': iconAllTiers,
  'seat-premium': iconSeatPremium,
  gift: iconGift,
  star: iconStar
};

const ICON_OPTIONS = [
  { value: 'ticket', label: 'Ticket' },
  { value: 'stadium', label: 'Stadium' },
  { value: 'raffle', label: 'Raffle' },
  { value: 'gold', label: 'Gold' },
  { value: 'mail', label: 'Mail' },
  { value: 'seat', label: 'Seat' },
  { value: 'jersey', label: 'Jersey' },
  { value: 'silver-gold', label: 'Silver Gold' },
  { value: 'megaphone', label: 'Megaphone' },
  { value: 'all-tiers', label: 'All Tiers' },
  { value: 'seat-premium', label: 'Premium Seat' },
  { value: 'gift', label: 'Gift' },
  { value: 'star', label: 'Star' }
];

const NoteItem = ({ note, index, onChange, onRemove }) => {
  const currentIcon = ICON_IMAGES[note.icon] || ICON_IMAGES.ticket;

  return (
    <NoteRow>
      <IconSelectWrapper>
        <IconPreview src={currentIcon} alt={note.icon} />
        <IconSelect
          value={note.icon}
          onChange={(e) => onChange(index, { ...note, icon: e.target.value })}
        >
          {ICON_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </IconSelect>
      </IconSelectWrapper>

      <Col wid="100%" gap="8px">
        <Input
          value={note.text}
          onChange={(e) => onChange(index, { ...note, text: e.target.value })}
          placeholder="Enter note text..."
        />
        <Input
          value={note.textJa || ''}
          onChange={(e) => onChange(index, { ...note, textJa: e.target.value })}
          placeholder="日本語のノートテキストを入力..."
        />
      </Col>

      <Clickable onClick={() => onRemove(index)}>
        <FiTrash2 size={18} color={theme.GREY_60} />
      </Clickable>
    </NoteRow>
  );
};

const AvailabilityNotesEditor = ({ value = [], onChange }) => {
  const handleAdd = () => {
    onChange([...value, { icon: 'ticket', text: '', textJa: '' }]);
  };

  const handleChange = (index, note) => {
    const newNotes = [...value];
    newNotes[index] = note;
    onChange(newNotes);
  };

  const handleRemove = (index) => {
    const newNotes = value.filter((_, i) => i !== index);
    onChange(newNotes);
  };

  return (
    <Col wid="100%">
      <Row between center marg="0 0 12px">
        <Text b2 med>
          Availability Notes
        </Text>
        <Text c1 col={theme.GREY_50}>
          {value.length} note{value.length !== 1 ? 's' : ''}
        </Text>
      </Row>

      {value.map((note, index) => (
        <NoteItem
          key={index}
          note={note}
          index={index}
          onChange={handleChange}
          onRemove={handleRemove}
        />
      ))}

      <AddButton type="button" onClick={handleAdd}>
        <FiPlus size={16} style={{ marginRight: 8 }} />
        Add Note
      </AddButton>
    </Col>
  );
};

export default AvailabilityNotesEditor;
